/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2019. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EventsService, FormHelpersService, UtilsService } from '@shared/services';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-team-selection-modal',
  templateUrl: './team-selection-modal.component.html',
  styleUrls: ['./team-selection-modal.component.scss'],
})
export class TeamSelectionModalComponent implements OnInit {
  @Input() eventData: any;

  @Output() closeModal: EventEmitter<any> = new EventEmitter();

  subject: string;
  teams: any[];
  teamsForm: FormGroup;
  selectedTeams: any[];
  showEdit = true;
  showConfirmation = false;
  processing = false;
  summaryErrorMessage: string;
  // used for soccer events where a user
  // can select more than one team that they played for
  selectMultipleTeamsLink = false;

  constructor(
    public fhs: FormHelpersService,
    private eventsService: EventsService,
    private utilsService: UtilsService,
    private router: Router
  ) {}

  ngOnInit() {
    if (!this.eventData) {
      return;
    }

    this.subject = this.utilsService.isAthleteSport(this.eventData.sport.name, this.eventData.eventType)
      ? 'athlete'
      : 'team';
    this.eventsService.getEventTeams(this.eventData.id).subscribe((response) => {
      this.teams = response.teams.map((team) => ({ name: team.name, value: team.id }));
    });

    this.teamsForm = new FormGroup({
      0: new FormControl(null, Validators.required),
    });

    if (this.eventData.sport && this.eventData.sport.name === 'Soccer') {
      this.selectMultipleTeamsLink = true;
    }
  }

  close() {
    this.closeModal.emit({ success: false });
  }

  submit() {
    if (this.teamsForm.valid) {
      const teams = this.teamsForm.value;
      this.selectedTeams = Object.keys(teams).map((key) => {
        const selectedTeam = this.teams.find((team) => team.value === teams[key]);
        return { id: selectedTeam.value, name: selectedTeam.name };
      });
      this.showEdit = false;
      this.showConfirmation = true;
    } else {
      this.summaryErrorMessage = 'Please select a team';
    }

    this.fhs.markFieldsAsDirty(this.teamsForm);
  }

  goBack() {
    this.showEdit = true;
    this.showConfirmation = false;
  }

  confirm() {
    this.processing = true;
    this.closeModal.emit({ success: true, teams: this.selectedTeams });
  }

  showSecondTeam($event) {
    $event.preventDefault();
    this.teamsForm.addControl('1', new FormControl(null, Validators.required));
  }
}
